<app-bs4-alert *ngIf="errorShow" [message]="errorMessage" [messages]="errorMessages" type="danger"></app-bs4-alert>
<app-bs4-alert *ngIf="sent" message="We have sent you an activation code. Check your mailbox to confirm your account." type="success"></app-bs4-alert>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-validate mb-3" role="form" name="verifyForm" novalidate="">
    
    <div class="form-group">
        <label class="text-muted mb-1">{{ 'Email address' | translate }}</label>
        <div class="input-group with-focus">
            <input formControlName="email" class="form-control border-right-0" type="email" name="email" placeholder="{{ 'Enter' | translate }} email" required="" />
            <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                    <fa-icon [icon]="['fas', 'envelope']"></fa-icon>
                </span>
            </div>
        </div>
        <mat-error field-error [control]="email" [messages]="validationMessages"></mat-error>
    </div>
    
    <button [disabled]="loading" class="btn btn-block btn-primary mt-3" type="submit">{{ 'Send mail' | translate }}</button>

</form>